import { render, staticRenderFns } from "./ViewMemberProfile.vue?vue&type=template&id=21c4f5d6"
import script from "./ViewMemberProfile.vue?vue&type=script&lang=js"
export * from "./ViewMemberProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports